<template>
  <el-container class="BomForm">
    <el-main class="p-0 pb-default">
      <el-row>
        <el-col :span="10">
          <el-input v-model="data.name" readonly>
            <template slot="prepend">품목명</template>
          </el-input>
        </el-col>
        <el-col :span="1" :offset="1">
          <ACheckboxYN v-model="bom.use_flag">사용</ACheckboxYN>
        </el-col>
        <el-col :span="1" :offset="1">
          <ACheckboxYN v-model="bom.is_use_assembled"
            >조립품 사용<AHelper
              >체크 시 이 제품이 포함된 모든 BOM에 조립품을 사용합니다.</AHelper
            ></ACheckboxYN
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="text-warning">{R}=레일사이즈, {B}=벨트사이즈</span>
        </el-col>
      </el-row>
      <div class="row-splitter">
        <ATable
          ref="table"
          hide-top-panel
          hide-pagination
          :data="items"
          :disable_insert="!has_grant_write"
          @cell-click="handleCellClick"
          @clicked-create="handleClickCreate"
        >
          <el-table-column
            type="index"
            label="No"
            prop="index"
            :width="$width.index"
            :index="handleIndex"
          />
          <el-table-column
            label="품목명"
            prop="product_id"
            :width="250"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <AProductSelector
                  size="tiny"
                  :value="resolveProductName(scope.row.product_id)"
                  @select="handleSelectProduct($event, scope.row)"
                />
              </div>
              <div v-else>
                {{ resolveProductName(scope.row.product_id) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="소요량" prop="amount" :width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <ANumberInput v-model="scope.row.amount" allowDecimal />
              </div>
              <div v-else>
                {{ scope.row.amount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="단위" prop="unit_id" :width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <AProductUnitSelector
                  size="tiny"
                  v-model="scope.row.unit_id"
                  :id="scope.row.product_id"
                />
              </div>
              <div v-else>
                {{ resolveUnit(scope.row.unit_id) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="규격" prop="size" :width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <el-input size="tiny" v-model="scope.row.size" />
              </div>
              <div v-else>
                {{ scope.row.size }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="조건"
            prop="condition"
            :width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <el-input size="tiny" v-model="scope.row.condition" />
              </div>
              <div v-else>
                {{ scope.row.condition }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="순서" prop="seq" :width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <el-select size="tiny" v-model="scope.row.seq">
                  <el-option v-for="s in seq_list" v-bind:key="s" :value="s" />
                </el-select>
              </div>
              <div v-else>
                {{ scope.row.seq }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="비고" prop="desc" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <el-input
                  size="mini"
                  v-model="scope.row.desc"
                  v-bind:class="{
                    'readonly-noborder': scope.row.id !== editingId,
                  }"
                  :readonly="scope.row.id !== editingId"
                />
              </div>
              <div v-else>
                {{ scope.row.desc }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="is_use_assembled" align="center">
            <template slot="header">
              조립품 사용<AHelper
                >BOM이 있는 품목만 표시되며, [{{ data.name }}]을 생산할 때
                체크된 제품은 하위 품목의 재고가 소모되지 않고, [{{
                  data.name
                }}]이 사용된 상위 품목에 영향을 미칩니다.</AHelper
              >
            </template>
            <template
              v-if="resolveUseBom(scope.row.product_id)"
              slot-scope="scope"
            >
              <ACheckboxYN
                v-model="scope.row.is_use_assembled_detail"
                class="custom-disabled-checkbox"
              ></ACheckboxYN>
            </template>
          </el-table-column> -->
          <el-table-column label="명령" width="150">
            <template slot-scope="scope">
              <div v-show="scope.row.id === editingId">
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="!has_grant_write"
                  :loading="load_button"
                  @click="handleClickUpdate(scope.row)"
                  >저장</el-button
                >
                <el-button size="mini" @click="calcelEditing(scope.row)"
                  >취소</el-button
                >
              </div>
              <div v-show="scope.row.id !== editingId">
                <el-button
                  type="danger"
                  size="mini"
                  :disabled="!has_grant_write"
                  :loading="load_button"
                  @click="handleClickRemove(scope.row)"
                  >삭제</el-button
                >
              </div>
            </template>
          </el-table-column>
        </ATable>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="editingId > -1 || !has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button
        type="danger"
        v-if="!is_new"
        :disabled="!has_grant_write"
        @click="handleClickDelete"
        >{{ $t("button.delete") }}</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "BomForm",
  mixins: [form],
  data() {
    return {
      title: this.$t("lang.product_bom"),
      bom: {
        use_flag: "Y",
        details: [],
      },
      items: [],
      newId: 1,
      editingId: -1,
      oldItem: undefined,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_product", "table_unit"]),
    /** 신규 여부 */
    is_new() {
      return this.bom && !this.bom.id;
    },
    seq_list() {
      let items = [];
      for (let i = 0; i < this.items.length; i++) {
        items.push(i + 1);
      }
      return items;
    },
  },
  mounted() {
    this.loadData();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  methods: {
    loadData() {
      this.api.selectBOM(this.data.id).then((res) => {
        this.bom = res.data;
        if (!this.bom) {
          this.bom = {
            product_id: this.data.id,
            use_flag: "Y",
            details: [],
          };
        }
        this.items = Object.assign([], this.bom.details);
        this.items.forEach((item) => {
          if (item.id >= this.newId) {
            this.newId = item.id + 1;
          }
        });
      });
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      const responseData = {
        product_id: this.bom.product_id,
        bom_use_flag: null,
        bom_details_length: 0,
      };
      this.api.deleteBOM(this.bom).then((res) => {
        this.load_button = false;
        this.handleResponse(res, "삭제되었습니다.", responseData);
      });
    },
    resolveProductName(id) {
      if (!id) {
        return "";
      }
      let product = this.table_product.find((p) => p.id === id);
      return product ? product.name : "";
    },
    resolveUseBom(id) {
      if (!id) {
        return "";
      }
      let product = this.table_product.find((p) => p.id === id);
      return product ? product.bom_flag === "Y" : false;
    },
    resolveUnit(id) {
      if (!id) {
        return "";
      }
      let unit = this.table_unit.find((u) => u.id === id);
      return unit ? unit.name : "";
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = {
        id: 0,
        product_id: undefined,
        unit_id: null,
        seq: this.items.length + 1,
        amount: "",
        size: "",
        condition: "",
        desc: null,
        is_new: true,
      };
      this.items.push(this.oldItem);
    },
    handleSelectProduct(product, data) {
      if (!product || typeof product === "string") {
        data.product_id = undefined;
      } else {
        data.product_id = product.id;
      }
    },
    handleClickUpdate(data) {
      if (!data.product_id) {
        this.util.notify_warning(this, this.title, "품목을 선택하세요.");
        return;
      }
      if (!data.amount) {
        this.util.notify_warning(this, this.title, "소요량을 입력하세요.");
        return;
      }
      if (data.product_id === this.data.id) {
        this.util.notify_warning(this, this.title, "품목과 BOM이 동일합니다.");
        return;
      }
      let isDuplicated = false;
      this.items.forEach((item) => {
        if (item.id === data.id) {
          return true;
        }
        if (item.product_id === data.product_id) {
          isDuplicated = true;
          this.util.notify_warning(this, this.title, "BOM이 중복되었습니다.");
          return false;
        }
        // 2020-04-29 순서 중복 처리 제외
        // if (item.seq === data.seq) {
        //   isDuplicated = true;
        //   this.util.notify_warning(this, this.title, "순서가 중복되었습니다.");
        //   return false;
        // }
      });
      if (isDuplicated) {
        return;
      }
      if (!data.id) {
        data.id = this.newId++;
      }
      this.editingId = -1;
    },
    handleClickRemove(data) {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      let index = this.items.findIndex((i) => i.id === data.id);
      if (index < 0) {
        return;
      }
      this.items.splice(index, 1);
    },
    handleClickRegister() {
      if (!this.has_grant_write) return;

      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.bom.details = Object.assign([], this.items);
      let new_id = 0;
      this.bom.details.forEach((d) => {
        if (d.is_new) {
          d.id = new_id--;
        }
      });
      this.load_button = true;
      const responseData = {
        product_id: this.bom.product_id,
        bom_use_flag: this.bom.use_flag,
        bom_details_length: this.bom.details.length,
      };
      this.api.registerBOM(this.bom).then((res) => {
        this.load_button = false;
        this.handleResponse(res, "등록되었습니다.", responseData);
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(
        this,
        this.title + "[" + this.data.name + "]",
        this.doDelete
      );
    },
    handleResponse(res, success_message, data) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, success_message);
      this.$emit("completed", null, data);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";
.BomForm {
  .el-table td .cell {
    height: 30px;
  }
  .desc {
    font-weight: bold;
    color: $color-warning;
  }
}
</style>
